// @ts-nocheck
import { StatusBadge } from '../shared/StatusBadge';
import { fmtDate, pctFmt } from '../shared/voteRoomFormat';
import { getShareholderVoteStatus } from '../shared/voteRoomVoteStatus';

/** Three-cell summary card (Shares / % Eligible / Status) rendered at the top of slide-overs. */
export const VoteRoomShareholderSummary = ({ shareholder, eligibleShares, voteRoomClosed }) => {
  const statusVariant = getShareholderVoteStatus(shareholder, { voteRoomClosed });
  const pctEligible = eligibleShares > 0 ? shareholder.shares / eligibleShares : 0;

  return (
    <div className="overflow-hidden rounded-lg border border-gray-200/80 bg-white shadow-[0_1px_3px_rgba(0,0,0,0.04)]">
      <div className="border-b border-gray-100 px-4 py-3">
        <p className="text-sm font-semibold text-gray-900">{shareholder.name}</p>
        {shareholder.email ? (
          <p className="mt-0.5 truncate text-xs text-gray-500" title={shareholder.email}>
            {shareholder.email}
          </p>
        ) : null}
      </div>
      <div className="grid grid-cols-3 divide-x divide-gray-100">
        <div className="px-4 py-3">
          <p className="text-[10px] font-semibold uppercase tracking-wider text-gray-400">Shares</p>
          <p className="mt-1 text-sm font-semibold text-gray-900 tabular-nums">{shareholder.shares.toLocaleString()}</p>
        </div>
        <div className="px-4 py-3">
          <p className="text-[10px] font-semibold uppercase tracking-wider text-gray-400">% Eligible</p>
          <p className="mt-1 text-sm font-semibold text-gray-900 tabular-nums">{pctFmt(pctEligible)}</p>
        </div>
        <div className="px-4 py-3">
          <p className="text-[10px] font-semibold uppercase tracking-wider text-gray-400">Status</p>
          <div className="mt-1.5">
            <StatusBadge variant={statusVariant}>{statusVariant}</StatusBadge>
          </div>
        </div>
      </div>
      {shareholder.signedAt ? (
        <div className="border-t border-gray-100 bg-gray-50/40 px-4 py-2.5 text-xs text-gray-600">
          Signed <span className="font-medium text-gray-900">{fmtDate(shareholder.signedAt)}</span>
        </div>
      ) : null}
    </div>
  );
};
